<template>
<div class="main p34">
	<div class="my-title">{{info.productName}}</div>
	<div class="fixed-bottom mt10">
		参保人员：
		<UploadFile
			ref="uploadFile"
			style="display:inline-block"
			url="/pc/broker/import/importEndorseEmployee"
			:show-upload-list="false"
			:data="uploadParams"
			btn-text="上传人员"
			@on-success="uploadSuccessList" 
			@on-file="filesName"
		/>
		点击<a @click="download">下载</a>批单模板&nbsp;&nbsp;
		<span v-if="remark">
			工种编号请通过
			<a :href="remark" target="_blank">职业类别表</a>
			查看
		</span>
	</div>
	<div class="mt15" v-if="files.name">
		<Row>  
			<Col span="22">{{ files.name }}</Col>
			<Col span="2" style="text-align: right">
				<a href="#" @click="deleteFile">删除</a>
			</Col>
		</Row>
	</div>
	<div class="mt15" v-if="info.productCode!='SUNLIGHT_EMPLOYER_LIABILITY'&&newList.length>0">
		<Row v-for="(item,index) in newList" :key="index" class="mt10" v-show="(index<3&&!foldBtn)||(foldBtn&&index>=0)">
			<span class="red">方案名称：</span>{{ item.schemeName }}&nbsp;&nbsp;&nbsp;
			<span class="red">工种编码：</span>{{ item.jobTypeCode }}&nbsp;&nbsp;&nbsp;
			<span class="red">工种名称：</span>{{ item.jobTypeName }}
		</Row>
		<div class="mt15" v-if="newList.length>3">
			<a @click="foldBtn=!foldBtn">
				{{ foldBtn?'收起':'展开' }}
				<Icon v-if="foldBtn" type="ios-arrow-up"></Icon>
				<Icon v-if="!foldBtn" type="ios-arrow-down"></Icon>
			</a>
		</div>
    </div>
	<el-table class="mt10" ref="selection" :data="tableData" border style="width: 100%">
		<el-table-column fixed prop="checkMsg" label="校验结果" width="150">
			<template slot-scope="{ row }">
				<span style="color:red" v-if="!row.checkResult.empty">
					{{row.checkResult.result}}
				</span>
				<span style="color:green" v-else>
					校验通过
				</span>
			</template>
		</el-table-column>
		<el-table-column prop="operationDesc" label="变更情况" width="100"></el-table-column>
		<el-table-column prop="insuredPersonName" label="新增人姓名" width="120"></el-table-column>
		<el-table-column prop="idCard" label="新增人身份证号" width="190"></el-table-column>
		<template v-if="info.productCode!='SUNLIGHT_EMPLOYER_LIABILITY'">
			<el-table-column prop="jobTypeCode" label="工种编码" width="150"></el-table-column>
		</template>
		<template v-else>
			<el-table-column prop="jobTypeName" label="岗位名称" show-overflow-tooltip width="150"></el-table-column>
			<el-table-column prop="jobTypeCategoryName" label="工种名称" show-overflow-tooltip width="150"></el-table-column>
		</template>
		<el-table-column prop="schemeName" label="方案" show-overflow-tooltip width="150"></el-table-column>
		<template v-if="info.productCode!='SUNLIGHT_EMPLOYER_LIABILITY'">
			<el-table-column prop="refInsuredPersonName" label="原姓名" width="120"></el-table-column>
			<el-table-column prop="refIdCard" label="原身份证号" width="190"></el-table-column>
			<el-table-column prop="refJobTypeCode" label="原工种编码" width="150"></el-table-column>
		</template>
		<el-table-column prop="companyNameFrom" label="新派遣单位" show-overflow-tooltip width="150"></el-table-column>  
		<el-table-column prop="companyNameTo" label="新实际用工单位" show-overflow-tooltip width="150"></el-table-column>
		<template v-if="info.productCode!='SUNLIGHT_EMPLOYER_LIABILITY'">
			<el-table-column prop="desc" label="新工作描述" show-overflow-tooltip width="150"></el-table-column>
		</template>
		<el-table-column prop="province" label="用工省" show-overflow-tooltip width="150"></el-table-column>
		<el-table-column prop="city" label="用工市" show-overflow-tooltip width="150"></el-table-column>
		<el-table-column prop="district" label="用工区" key="district" show-overflow-tooltip width="150"></el-table-column>
		<el-table-column fixed="right" label="操作" width="130">
			<template slot-scope="scope">
				<a @click="del2(scope.$index,scope.row.idCard)">删除</a>
			</template>
		</el-table-column>
	</el-table>
	<Row class="mt10" v-if="orderDataConfirmShow.length>0">
		<Col :span="24" class="right">
			<el-pagination
				:current-page="pageinfo.page"
				:page-size="pageinfo.size"
				:total="pageinfo.total"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="prev, pager, next"
			>
			</el-pagination>
		</Col>
	</Row>
	<!-- 核保中 -->
	<div v-if="endorseStatus=='REVIEWING'">
		<div class="mt10 center">
			<Button type="primary" disabled>核保中</Button>
			<div class="mt20">
				1、如您在等待过程中需关闭此页面，则该批改单可以在【用户中心-我的保全】中将批改单状态选择为“核保中”，进行查看。
				2、如核保通过，则进入【用户中心-我的订单-选择待支付订单】进行后续支付流程即可。
			</div>
		</div>
	</div>
	<!-- 核保失败 -->
	<div v-if="endorseStatus=='REVIEWED_REJECTED'">
		<p class="mt10 center" style="color: red;">
			失败原因：{{ info.remark }}
		</p>
		<div class="mt10 center">
			<Button type="primary" :disabled="!files.name||!show" @click="sub">提交</Button>
		</div>
	</div>
	<div v-if="endorseStatus!='REVIEWED_REJECTED'&&endorseStatus!='REVIEWING'" class="center mt10">
		<Button type="primary" :disabled="!files.name||!show" @click="sub">提交</Button>
	</div>
	<Modal
		v-model="confirmShow"
		title="人员信息变更"
        width="400px"
        :mask-closable="false">
		<Form :label-width="130">
			<div style="display:flex;align-items: top; margin-bottom:15px;">
				<p style="width:100px;text-align:right;padding-right: 12px;">保费合计：</p>
				<p>{{ Math.abs(confirmForm.premium) }}元<br/>
					<span style="font-size:12px;color:red;">以上为预估费用，具体批改保费请以批单为准</span>	
				</p>
			</div>
			<FormItem label="上传批改申请书：" v-if="confirmForm.premium>=0">
				<UploadFileImg 
					@on-success="val=>uploadSuccess(val)" 
					:accept="['image','pdf']"
					type="select" 
					btn-text="上传批改申请书"></UploadFileImg>
                <div v-if="correctUrlList.length>0">
                    <p v-for="(item,index) in correctUrlList" :key="index" >
                        批改申请书{{index+1}}&nbsp;&nbsp;&nbsp;<a :href="item" target="_blank" class="ml10" :key="index">查看</a>&nbsp;<a style="color:#ed4014" @click="del(index)">删除</a>
                    </p>
                </div>
		    </FormItem>
		</Form>
		<template slot="footer">
			<span v-if="confirmForm.premium<0" class="edit-warning">本产品不支持退费，此次修改无效</span>
			<Button type="text" @click="confirmShow=false" v-if="confirmForm.premium<0">关闭</Button>
			<Button type="text" @click="confirmShow=false;confirmLoading=false;" v-if="confirmForm.premium>=0">取消</Button>
			<span>
				<Button type="primary" @click="confirmSub" 
				v-if="confirmForm.premium >= 0" :loading="confirmLoading">确定</Button>
			</span>
		</template>
		<TrackNotice :companyName="this.info.subjectName" />
	</Modal>
</div>
</template>
<script>
import UploadFile from './common/UploadFile'
import UploadFileImg from './common/UploadFileImg'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
import { mapState } from 'vuex'
export default {
	components:{ UploadFileImg,UploadFile,TrackNotice },
	mixins:[track],
	data () {
		return {
            correctUrlList:[],
			info:{},
			originalList:[],// 原始数据
			id:this.$route.params.id,
			confirmShow:false,
			confirmForm:{},
			confirmLoading:false,
			isReset:this.$route.query.reset||'', // reset=1重新投保
			orderNo:this.$route.query.orderNo||'',
			orderDataConfirm:[], // 确认批量操作信息人员
			canTrue:false,
			files:{},
			endorseNo:'',
			endorseStatus:'',
			timer:null,
			orderDataConfirmShow:[],
			newList:[],
			foldBtn:false,
			remark:'',
			tableData:[],
			pageinfo: {
				page: 1,
				size: 20,
				total: 0,
			}
		}
	},
	computed: {
		uploadParams(){
			return {
				endorse:JSON.stringify({
					productCode:this.$route.query.productCode||this.info.productCode,
					bizId:'INDUSTRY_ENTERPRISE',
					insurancePolicyId: this.info.insurancePolicyId
				})
			}
		},
		show(){
			return this.orderDataConfirmShow.length>0&&(this.orderDataConfirmShow.findIndex(item => item.checkResult.empty=== false)==-1)
		}
	},
	created () {
		this.getInfo();
	},
	mounted(){
		// 回溯 开始录制
		this.track_is_new = true;
		this.$nextTick(()=>{
			this.trackInit();
		})
	},
	beforeDestroy() {
		//在 beforeDestroy生命周期函数中销毁定时器
		clearInterval(this.timer);
		this.timer = null;
	},
	beforeRouteLeave (to, from, next) {
		this.confirmShow = false;
		this.$nextTick(()=>{
			next();
		})
	},
	methods:{
		/** 切换每页显示条数 */
		handleSizeChange(val) {
			this.pageinfo.page = 1;
			this.pageinfo.size = val;
			this.tableData = this.currentChangePage(val, this.pageinfo.page);
			this.pageinfo.total = this.orderDataConfirmShow.length;
		},
		/** 切换分页 */
		handleCurrentChange(val) {
			this.pageinfo.page = val;
			this.tableData = this.currentChangePage(this.pageinfo.size, val);
			this.pageinfo.total = this.orderDataConfirmShow.length;
		},
		// 分页方法
		currentChangePage(size, current) {
			const tablePush = [];
			let array = JSON.parse(JSON.stringify(this.orderDataConfirmShow));
			array.forEach((item, index) => {
				if (size * (current - 1) <= index && index <= size * current - 1) {
				tablePush.push(item);
				}
			});
			return tablePush;
		},
		// 文件名
		filesName(file){
			this.files = file;
		},
		// 删除
		deleteFile(){
			this.confirm('确定删除该文件？',()=>{
				this.files = {};
				this.$refs.uploadFile.removeFile();
			})
		},
		async getJob(){
			await this.$axios.post('/broker/dict/find.json',{
				bizId:'INDUSTRY_ENTERPRISE',
				companyId: this.info.companyId,
				dictCode:'work_type',
				productCode: this.info.productCode,
				version:  this.info.dictVersion
			}).then((res) => {
				this.remark = res.remark;
			})
		},
		convertTree (tree) {
			let list = tree.map(item=>{
				return {
					...item,
					loading: false
				}
			})
			let result = JSON.parse(JSON.stringify(list).replace(/"value"/g,"label").replace(/"key"/g,"value"))
			return result
		},
		// 下载模板
		downloadPd() {
			let list= this.jsonCopy(this.confirmForm.subjectMatter.filter(item=>{
				return item.operation=='ADD'||item.operation=='EDIT'||item.operation=='REMOVE'||item.operation=='REPLACE'||item.operation=='REPLACED'
			}))
			let data = {}
			if(this.info.productCode=='PICC_EMPLOYER_LIABILITY'){
				data = {
					cntrNo: this.info.cntrNo,
					policyId: this.info.insurancePolicyId,
					subjectMatter: list,
					bizId: 'INDUSTRY_ENTERPRISE',
					productCode: this.info.productCode
				}
			} else {
				data = {
					cntrNo: this.info.cntrNo,
					insurancePolicyId: this.info.insurancePolicyId,
					subjectMatter: list,
					bizId: 'INDUSTRY_ENTERPRISE',
					productCode: this.info.productCode
				}
			}
			this.$axios.post('/broker/export/exportEndorse.json',data).then(res=>{
				if(res){
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '保险合同变更申请书')
					})
				}
			})
		},
		/*获取订单信息*/
		async getInfo () {
			let obj = {insurancePolicyId:this.id}
			let res = await this.$axios.get('/broker/insurance/policy/detail',obj)
			this.info=res;
			this.getJob();
			res.subjectMatter=res.subjectMatter.map(item=>{
				item.operation='INIT'
				return item
			})
			this.newList = this.unique(res.subjectMatter)
			// this.originalList=this.jsonCopy(res.subjectMatter);
			// this.orderDataConfirm = res.subjectMatter;
		},
		// 删除新增
		del2(index,idCard) {
			this.confirm('确定删除该人员？',()=>{
				this.tableData.splice(index,1);
				this.orderDataConfirm.forEach((item,inx)=>{
					if(item.idCard==idCard){
						this.orderDataConfirm.splice(inx,1)
					}
				})
				this.orderDataConfirmShow.forEach((item,inx)=>{
					if(item.idCard==idCard){
						this.orderDataConfirmShow.splice(inx,1)
					}
				})
			})
		},
		// 价格格式化，最多2位小数
		numFormat(num){
			return Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))
		},
		// 提交
		sub() {
			if(this.isReset){	
				this.orderDataConfirm.forEach((item)=>{ 
					if (item.id){   
						delete  item.id;  
					}
				})
			}
			let str = this.info.productCode=='ZHONGAN_EMPLOYER_LIABILITY'?'即将进入核保信息录入与提交流程，对应核保结果将在10分钟内确认完毕，<br />1、如您在等待过程中需关闭此页面，则该批改单可以在【用户中心-我的保全】中将批改单状态选择为“核保中”，进行查看。<br />2、如核保通过，则进入【用户中心-我的订单-选择待支付订单】进行后续支付流程即可。':'确定提交信息？'
			this.confirm(str,()=>{
				this.$axios.post('/broker/insurance/endorse/apply.json.all.dst',{
					insurancePolicyId:this.id,
					subjectMatter: this.orderDataConfirm
				}).then(res=>{
					this.confirmForm = res.data;
					this.confirmShow=true;
				})
			})
		},
		getSatus(){
			setTimeout(()=>{
				this.$axios.get('/broker/insurance/endorse/detailByEndorseNo', { endorseNo: this.endorseNo }).then(res=>{
					this.endorseStatus = res.endorseStatus;
					if(res.endorseStatus =='CONFIRMED'||res.endorseStatus =='FINISHED'){
						// 调获取订单号接口
						this.$axios.post('/broker/order/list.json',{
							bizId:'INDUSTRY_ENTERPRISE',
							applicationNo: this.info.applicationNo,
							count:10,
							page:1
						}).then(async res=>{
							clearInterval(this.timer)
							// 回溯 停止录制
							await this.stopRecord({
								session_key:sessionStorage.track_session_key,
								policy_id: res[0].endorseNo
							});
							this.confirmLoading=false;
							window.location.href=`/common.html#/payCCIC?orderNo=${res[0].orderNo}&productCode=${this.info.productCode}`
						}).catch(err=>{
							clearInterval(this.timer)
						})
					} else if(res.endorseStatus =='REVIEWED_REJECTED'||res.endorseStatus =='REJECTED'){
						this.confirmLoading=false;
						this.info.remark = res.remark;
						clearInterval(this.timer)
					}
				}).catch(err=>{
					this.confirmLoading=false;
					clearInterval(this.timer)
				})
          	}, 0)
		},
		// 确认跳转
		confirmSub() {
			if(this.correctUrlList.length==0){
				this.alert('请上传批改申请书！')
				return
			}
			if(this.confirmLoading){
				return
			}
			this.confirmLoading=true;
			let data = {
				insurancePolicyId: this.confirmForm.insurancePolicyId,
				subjectMatter: this.orderDataConfirm,
				premium: this.confirmForm.premium
			}
			if(this.correctUrlList.length>0){
				data.subjectMatterUrls = this.correctUrlList.join(',')
			}
			this.$axios.post('/broker/insurance/endorse/confirm.json',data).then(async res=>{
				this.confirmShow=false
				if(res&&res.charAt(0)=='E'){
					this.confirmShow = false;
					this.endorseNo = res
					this.getSatus();
					this.timer = setInterval(() => {
						this.getSatus()
					}, 5000)
				} else {
					// 泰康 批单号
					this.$axios.post('/broker/order/detail',{
						orderNo: res
					}).then(async respon=>{
						// 回溯 停止录制
						await this.stopRecord({
							session_key:sessionStorage.track_session_key,
							policy_id: respon.endorseNo
						});
						this.confirmLoading=false;
						window.location.href=`/common.html#/payCCIC?orderNo=${res}&productCode=${this.info.productCode}`
					})
				}
			});
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		},
		// 下载模板
		async download() {
			let res =  await this.$axios.post('/broker/export/exportEmptyExcelTemplate.json',{
				productCode:this.info.productCode,
				policyId:this.info.insurancePolicyId
			})
			if(res){
				this.getBlob(res).then((blob) => {
					this.saveAs(blob, '批量上传模板')
				})
			}
		},
		/*上传成功后获取数据*/
		uploadSuccessList (res) {
			this.canTrue = false
			this.orderDataConfirm = res||[]
			this.orderDataConfirm.forEach(el=>{
				if (!el.checkResult.empty) this.canTrue = true
			})
			this.orderDataConfirmShow =this.jsonCopy(res.filter(item=>{
				return item.operation!='REPLACED'
			}))
			this.pageinfo.total = this.orderDataConfirmShow.length;
			this.tableData = this.currentChangePage(this.pageinfo.size,this.pageinfo.page);
		},
        /*上传成功后获取数据*/
		uploadSuccess (res) {
            if(this.correctUrlList.length<5) {
                this.correctUrlList.push(res.url)
            } else {
                this.alert('最多上传5张批改单！')
            }
		},
		unique(arrList){
			const res = new Map();
			return arrList.filter((arr) => !res.has(arr.jobTypeCode) && res.set(arr.jobTypeCode, arr.jobTypeCode));
		},
        del (index) {
            this.correctUrlList.splice(index, 1)
        },
		// json数组去重
		uniqueArray(array, key){
			let result = [array[0]];
			for(var i = 1; i < array.length; i++){
				var item = array[i];
				var repeat = false;
				for (var j = 0; j < result.length; j++) {
					if (item[key] == result[j][key]) {
						repeat = true;
						break;
					}
				}
				if (!repeat) {
					result.push(item);
				}
			}
			return result;
		}
	}
}
</script>
<style scoped lang="less">
.main{
	margin-top:24px;
	min-height: 100vh;
}
.fixed-bottom{
	z-index: 99;
	// position: fixed;
    padding: 10px;
	background: #fff;
	box-shadow: #eaeaea 0px 0px 10px;
	padding: 10px;
	// bottom: 150px;
}
.mb0{
	margin-bottom: 0;
}
.edit-warning{
	font-size: 1em;
	color: red;
	margin-right: 20px;
}
.errorMsg{
	font-size: 1em;
	color: red;
	float: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/EditBatch.vue